import { render, staticRenderFns } from "./BpButtonExport.vue?vue&type=template&id=8c84f3f6&"
import script from "./BpButtonExport.vue?vue&type=script&lang=js&"
export * from "./BpButtonExport.vue?vue&type=script&lang=js&"
import style0 from "./BpButtonExport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports